import { pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { AppVersion } from 'click-types';
import { appInfoSelector } from '@common/redux/selectors/app';
import { checkFont } from '../func';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};

  return StyleSheet.create({
    container: {
      ...pick(attributes, ['marginTop', 'marginLeft']),
      ...(attributes.style?.marginTop !== undefined && {
        marginTop: attributes.style.marginTop,
      }),
      ...(attributes.style?.marginLeft !== undefined && {
        marginLeft: attributes.style.marginLeft,
      }),
      ...(style?.marginRight !== undefined && {
        marginRight: style.marginRight,
      }),
      ...(style?.marginBottom !== undefined && {
        marginBottom: style.marginBottom,
      }),
      ...(style?.margin !== undefined && {
        margin: style.margin,
      }),
      fontFamily: checkFont(
        attributes.style?.fontFamily || attributes.fontFamily
      ),
      zIndex: attributes.zIndex,
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
        ])),
    },
  });
};

export default createStyles;
